module.exports = __webpack_public_path__ + "img/jgqh0.eb316130.png";